import { environment } from '@environment/environment';

export const firebaseConfig = environment.firebase;

export const remoteConfigDefaults = {
  turn_on_analytics: true,
  turn_on_watheeq_flow: false,
};
